require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_core').Array.values;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/fn/dom-collections/iterator.js
// module id = 443
// module chunks = 1